import React, { useEffect, useState, useRef } from "react";
import Grid from "@mui/material/Grid2";
import { API_GAME } from "../../../../constants/api";
import {Box } from "@mui/material";

const APDFViewer = ({ infoActivity }) => {
  const containerRef = useRef(null);

  if (!infoActivity) return null;

  return (
    <Grid
      item
      xs={12}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {/* CONTAINER DO PDF */}
      <Box
        ref={containerRef}
        sx={{
          border: "solid 3px #662d91",
          width: "100%",
          height: "80vh", 
          margin: "15px auto",
          minWidth: "320px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          "@media (max-width: 1024px)": {
            maxWidth: "90%",
          },
          "@media (max-width: 768px)": {
            maxWidth: "85%",
          },
          "@media (max-width: 425px)": {
            maxWidth: "100%",
          },
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: "100%"
          }}
        >
          <object 
            data={API_GAME + "/" + infoActivity.path + "/gabarito.pdf"}
            type="application/pdf"
            width="100%"
            height="100%"
            style={{ border: "none" }}
          />
        </Box>
      </Box>
    </Grid>
  );
};

export default APDFViewer;
